import { articleApiClient } from '@api/clients';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { Article } from '@api/api';
import { useArticlesCount } from './useArticlesCount';

export const fetchNextArticle = async (params) => {
  const { data } = await articleApiClient.articlesNextGet({ params });

  return { params, data };
};

export const useNextArticles = (
  countParams,
  defaultPageParam,
): { totalPages: number } & UseInfiniteQueryResult<{ data: Article; params: unknown }> => {
  const { data: articlesCount } = useArticlesCount(countParams);

  const infiniteQueryResult = useInfiniteQuery(
    'next-articles',
    ({ pageParam = defaultPageParam }) => fetchNextArticle(pageParam),
    {
      enabled: false,
    },
  );

  return { totalPages: articlesCount, ...infiniteQueryResult };
};
